import http from "@/http-common";

export default class MA501080Service {

	getList(_params) {
		return http.get('/ma/ma501080', { params: _params}).then(res => res.data);
	}

}